export default "__VITE_ASSET__CPT3pjT$__"